var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceNonCustodial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M45.566 22.902h-12.5v18.334h12.5c.92 0 1.667-.747 1.667-1.667v-15c0-.92-.747-1.667-1.667-1.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.733 27.272v2.035c0 .117 0 .314-.118.415L43.1 31.237c-.116.118-.234.118-.35 0l-.583-.466c-.117-.117-.117-.234 0-.35l.7-.7v-2.45h-2.1c-1.867 1.4-3.384 3.966-3.85 3.5-.583-.468 3.033-5.25 3.498-5.367h3.967c.233 0 .35.118.35.35v1.518z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.866 38.736h-2.035c-.117 0-.314 0-.415-.118L38.9 37.102c-.117-.117-.117-.234 0-.35l.467-.584c.117-.117.233-.117.35 0l.7.7h2.45v-2.1c-1.4-1.866-3.967-3.384-3.5-3.85.468-.583 5.25 3.034 5.367 3.5v3.966c0 .234-.118.352-.351.352Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.852 36.87v-2.036c0-.117 0-.314.117-.415l1.517-1.517c.116-.117.233-.117.35 0l.583.467c.117.117.117.233 0 .35l-.7.7v2.45h2.1c1.867-1.4 3.384-3.967 3.85-3.5.583.468-3.034 5.25-3.499 5.367h-3.966c-.234 0-.351-.118-.351-.351v-1.516Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.719 25.405h2.035c.117 0 .314 0 .415.117l1.515 1.517c.118.117.118.233 0 .35l-.466.583c-.117.118-.234.118-.35 0l-.7-.7h-2.45v2.1c1.4 1.867 3.966 3.385 3.5 3.85-.468.584-5.25-3.034-5.367-3.499v-3.966c0-.234.118-.351.35-.351h1.518z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "m34.733 47.07-17.5-3.334V20.402l17.5-3.333Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.9 39.413-6.667-.584V26.077l6.433-.697v2.57l-3.976.235v2.926l3.627-.116v2.568H24.69v3.046l4.21.233Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#13504f",
    d: "M15.038 1.688a9 9 0 1 0 0 18 9 9 0 1 0 0-18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#13a3a9",
    d: "M22.913 10.688a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 1 0 0-15.75z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ddaea",
    d: "M15.788 19.688a6 6 0 1 0 0 12 6 6 0 1 0 0-12z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#027178",
    d: "M14.527 24.188H2.048c-.696 0-1.26-.565-1.26-1.26v-12.48c0-.695.564-1.26 1.26-1.26h12.479c.696 0 1.26.565 1.26 1.26v12.48c0 .695-.564 1.26-1.26 1.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.612 20.25v-1.723c.32.262 1.793.786 2.175.786.224 0 1.603.066 1.603-.78 0-1.226-3.811-1.121-3.811-3.545 0-.402.05-2.294 3.1-2.294.78 0 1.703.196 1.97.296v1.61c-.132-.09-.667-.538-1.872-.538-1.407 0-1.53.662-1.53.781 0 1.02 3.749 1.158 3.749 3.533 0 2.38-2.71 2.306-3.133 2.306-.433 0-1.965-.288-2.251-.432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceNonCustodial);
export default __webpack_public_path__ + "static/media/sourceNonCustodial.9ffb4cb3a239985714b4f13470c36fba.svg";
export { ForwardRef as ReactComponent };